import React, { useContext, useState } from 'react';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import {
  ParPagComponentRequest,
  updatePageComponent,
} from 'services/displayFramework';
import { Input, notification } from 'antd';
import { AuthContext } from 'components/Auth/Auth';
import { SaveOutlined } from '@ant-design/icons';

type GetLabelProps = {
  label: string;
  style?: React.CSSProperties;
  Inspectstyle?: React.CSSProperties;
};

const GetLabel = ({ label, style, Inspectstyle }: GetLabelProps) => {
  const { getComponentLabel, pagcode, refresh } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);

  const [newLabel, setNewLabel] = useState('');

  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? getComponentLabel(label) : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request: request }).then((res) => {
      if (res.code === '200')
        notification.success({
          message: res.message,
          description: res.description,
        });
      else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };
  return isInspect ? (
    <Input
      defaultValue={newLabel === '' ? getComponentLabel(label) : newLabel}
      size="middle"
      onKeyDown={(e) => e.stopPropagation()}
      onChange={(event) => {
        event.preventDefault();
        setNewLabel(event.target.value);
      }}
      onClick={(event) => {
        event.preventDefault();
      }}
      style={Inspectstyle}
      className="input-inspect"
      addonAfter={
        <SaveOutlined
          onClick={(ev) => {
            ev.preventDefault();
            handleSaveNewLabel(label, newLabel);
          }}
        />
      }
    />
  ) : (
    <span style={style}>{getComponentLabel(label || '')}</span>
  );
};

export default GetLabel;
